import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * Render content in a card-like frame
 */
export default function Card({
  children,
  classes,
  elementRef,
  active = false,
  variant = 'raised',
  width = 'full',
  ...htmlAttributes
}) {
  return _jsx("div", {
    "data-component": "Card",
    ...htmlAttributes,
    ref: downcastRef(elementRef),
    className: classnames('rounded-lg border bg-white', {
      'shadow hover:shadow-md': variant === 'raised',
      // default
      'shadow-md': active && variant === 'raised'
    }, {
      'w-full': width === 'full',
      // default
      'w-auto': width === 'auto'
      // No width is set if `width === 'custom'`
    }, classes),
    children: children
  });
}
//# sourceMappingURL=Card.js.map